var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.93631 0.384766H10.502L7.08137 4.29447L11.1056 9.61455H7.95456L5.48673 6.38786L2.66289 9.61455H1.09619L4.75488 5.43274L0.894531 0.384766H4.12534L6.35613 3.334L8.93631 0.384766ZM8.38675 8.67733H9.25441L3.65397 1.27277H2.72303L8.38675 8.67733Z",
    fill: "#F0DE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.f92e2a0c0afde9fce496d612551bea8b.svg";
export { ForwardRef as ReactComponent };